<template>
    <div class="per-avatar-area">
        <img
            class="per-avatar"
            :src="
                avatarUrl(group.portraitUrl || group.url || group.portrait_url)
            "
            alt=""
            loading="lazy"
            :onerror="defaultGroupAvatar"
        >
    </div>
</template>

<script>
    import defaultAvatar from '@/assets/images/contacts/group_avatar.png'
    export default {
        name: 'Avatar',
        props: {
            group: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                defaultGroupAvatar:
                    'this.src="' +
                    require('@/assets/images/contacts/group_avatar.png') +
                    '"'
            }
        },
        methods: {
            avatarUrl(url) {
                if (!url) {
                    // return 'https://lupic.cdn.bcebos.com/20191203/3016916891_14.jpg' // 默认群头像
                    return defaultAvatar // 默认群头像
                }
                return url
            }
        }
    }
</script>

<style lang="scss" scoped>
    /*头像*/
    .per-avatar-area {
        width: 40px;
        height: 40px;
        position: relative;
        .per-avatar {
            width: 100%;
            height: 100%;
            background-color: #f5f5f5;
            border-radius: 50%;
            position: absolute;
        }
    }
</style>
